import { isUndefinedOrNull } from '../../../TypeHelpers';
export default function first(enumerable, predicate) {
    if (!isUndefinedOrNull(predicate)) {
        enumerable = enumerable.where(predicate);
    }
    const en = enumerable.getEnumerator();
    if (en.moveNext()) {
        return en.current;
    }
    throw new Error("The collection is empty!");
}
